import { useQuery, useQueryClient } from '@tanstack/react-query';
import unifiedApi from '../services/unifiedApi';

export const useSuperadminPlatform = () => {
  const queryClient = useQueryClient();

  const platformUsage = useQuery({
    queryKey: ['superadmin', 'platform-usage'],
    queryFn: async () => {
      const r = await unifiedApi.get('/superadmin/platform/usage');
      if (!r.success) throw new Error(r.message || 'Erreur plateforme');
      return r.data;
    },
    staleTime: 5 * 60_000,
    refetchInterval: 10 * 60_000,
  });

  const handlePurgeStaleTokens = async () => {
    const r = await unifiedApi.delete('/superadmin/platform/tokens/stale');
    if (!r.success) throw new Error(r.message || 'Erreur purge tokens');
    queryClient.invalidateQueries({ queryKey: ['superadmin', 'platform-usage'] });
    return r.data;
  };

  return {
    platformUsage: platformUsage.data ?? null,
    platformLoading: platformUsage.isLoading,
    handlePurgeStaleTokens,
    error: platformUsage.error?.message ?? null,
  };
};
